import Axios from 'axios'
import { paymentMethodUrls } from '../urls'
import { currencyUrls } from '../../CurrencyService/urls';
import router from '../../../router'

export default {
  fetch_mpesa_transactions (context) {
        Axios.get(paymentMethodUrls.getMpesaTransactions).then((response) => {
      context.commit('GET_MPESA_TRANSACTIONS', response.data)
    })
  },
  get_payment_platforms (context) {
    Axios.get(currencyUrls.getAllPaymentOptions).then(function (response) {
      context.commit('GET_ALL_PAYMENT_CHECKOUT', response.data)
    })
  },
  get_all_payment_methods (context) {
    Axios.get(paymentMethodUrls.getAllPaymentMethods).then(function (response) {
      context.commit('GET_ALL_PAYMENT_METHODS', response.data)
    })
  },
  get_all_credit_card_accounts (context) {
    Axios.get(paymentMethodUrls.getAllCreditCardAccounts).then(function (response) {
      context.commit('GET_ALL_CREDIT_CARD_ACCOUNTS', response.data)
    })
  },
  get_payment_methods (context, publicId) {
    Axios.get(paymentMethodUrls.getPaymentMethods + publicId).then(function (response) {
      context.commit('GET_PAYMENT_METHODS', response.data)
    })
  },
  post_payment_gateway (context, data) {
    Axios.post(paymentMethodUrls.postPaymentGateways, data).then(
      context.dispatch('get_all_credit_card_accounts')
    )
  },
  update_payment_gateway (context, data) {
    Axios.patch(paymentMethodUrls.updatePaymentGateways, data).then(
      context.dispatch('get_all_credit_card_accounts')
    )
  },
  get_deleted_payment_methods (context) {
    Axios.get(paymentMethodUrls.getDeletedPaymentMethod).then(function (response) {
      context.commit('GET_DELETED_PAYMENT_METHODS', response.data)
    })
  },
  get_payment_method (context, publicId) {
    Axios.get(paymentMethodUrls.getPaymentMethod + publicId).then(function (response) {
      context.commit('GET_PAYMENT_METHOD', response.data)
    })
  },
  post_payment_method (context, data) {
    Axios.post(paymentMethodUrls.postPaymentMethod, data).then(function () {
      context.dispatch('get_all_payment_methods')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_payment_method (context, data) {
    Axios.post(paymentMethodUrls.postPaymentMethod, data).then(function () {
      context.dispatch('get_all_payment_methods')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_payment_method (context, publicId) {
    Axios.get(paymentMethodUrls.deletePaymentMethod + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_PAYMENT_METHODS', response.data)
      router.push({
        name: 'Module.DeletedPaymentMethods'
      })
    })
  },
  restorePaymentMethod (context, publicId) {
    Axios.get(paymentMethodUrls.restorePaymentMethod + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PAYMENT_METHODS', response.data)
      router.push({
        name: 'Module.PaymentMethods'
      })
    })
  },
  get_jenga_auth (context) {
    Axios.get('https://bookings.olpejetaconservancy.org:5006/jenga/request').then((response) => {
      context.commit('JENGA_API_TOKEN', response.data)
    })
  }
  // get_jenga_auth(context) {
  //   Axios.get('https://4cb42076114e.ngrok.io/jenga/request').then((response) => {
  //     context.commit('JENGA_API_TOKEN', response.data)
  //   })
  // }
}
